<script setup lang="ts">
import { default as PPanel } from 'primevue/panel'
import { computed } from 'vue'

const props = defineProps<{
  title?: string
  toggleable?: boolean
  data?: any
  activeIndex?: number
  action?: (data: any) => void
  text?: boolean
}>()

const passThrough = computed(() => {
  if (props.text) {
    return {
      header: {
        style: {
          padding: '1rem 1.5rem',
          backgroundColor: 'transparent',
          borderBottom: 'none'
        }
      },
      content: {
        style: {
          padding: '0 1.5rem 1rem',
          backgroundColor: 'transparent'
        }
      }
    }
  }

  return null
})
</script>

<template>
  <p-panel
    class="border-primary-100 col-span-12 grid grid-cols-subgrid overflow-hidden rounded-xl border p-0"
    :toggleable="toggleable"
    :pt="passThrough ?? undefined"
  >
    <template #header>
      <slot name="title" :data="data">
        <h3 class="text-primary-900 col-span-12 font-[barlow] text-2xl font-bold uppercase">
          {{ title }}
          <template v-if="action">
            <i class="pi pi-external-link bo-active-color" @click.stop="action(data)"></i>
          </template>
        </h3>
      </slot>
    </template>

    <slot></slot>
  </p-panel>
</template>
